import View from './view.js'
import { useEffect } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data'

export default function Logic(props) {
  let selected = useDataValue({
    context: 'tab',
    path: 'selected.calendar_settings.location_id',
    viewPath: props.viewPath,
  })
  let setSelected = useDataChange({
    context: 'tab',
    path: 'selected.calendar_settings.location_id',
    viewPath: props.viewPath,
  })
  let locations = useDataValue({
    context: 'locations',
    viewPath: props.viewPath,
  })
  let globalLocationId = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (selected && locations.find(item => item._id === selected)) return
    setSelected(globalLocationId)
  }, [selected, locations, globalLocationId]) // eslint-disable-line

  return <View viewPath={props.viewPath} />
}
